const api = 'https://timebank.shenzhentimebank.cn/api/'

module.exports = {
  //管理员
  ADMIN: {
    findCarouselMapManage:api+'app/system/findCarouselMapManage',
    findDemandActivityByPage:api+'app/demand/activity/findDemandActivityByPage',
    getAboutInfo:api+'app/system/getAboutInfo/',
    findFriendshipLinkByPage:api+'app/system/findFriendshipLinkByPage',
    getConfigInfo:api+'app/system/getConfigInfo',
    getContactInfo:api+'app/system/getContactInfo',
    getUserAgreement:api+'app/system/getUserAgreement',
    searchId:api+'app/system/search/',
    findNewsByPage:api+'app/system/findNewsByPage',
    findPublicWelfareByPage:api+'app/system/findPublicWelfareByPage',
    findOne:api+'app/demand/activity/findOne',
    findMsgBoardByPage:api+'app/demand/activity/findMsgBoardByPage',
    findManagePage:api+'app/system/findManagePage',
    userCore:api+'app/user/core/',///获取当前用户信息
    changeMobile:api+'app/user/core/changeMobile',///用户更改绑定手机
    checkMobile:api+'app/user/core/checkMobile/',///检查手机号是否被注册
    findUserInfo:api+'app/user/core/findUserInfo/',///获取用户信息
    login:api+'app/user/core/login',///用户名密码或短信登录
    logout:api+'app/user/core/logout',///登出
    register:api+'app/user/core/register',///用户注册
    resetPWD:api+'app/user/core/resetPWD',///重置密码/忘记密码
    saveUserInfo:api+'app/user/core/saveUserInfo',///保存用户基本信息
    saveServerUserInfo:api+'app/user/core/server-info/save',///保存用户服务信息
    points:api+'app/user/points/',///保存用户服务信息
    findUserUndertakeByPage:api+'app/demand/activity/findUserUndertakeByPage',///分页获取我的承接/活动
    findServerAddressByPage:api+'app/server/findServerAddressByPage',///分页获取用户服务地址列表/活动
    serverSave:api+'app/server/save',///分页获取用户服务地址列表/活动
    serverInfo:api+'app/server/',///分页获取用户服务地址列表/活动
    loadDictionary:api+'base/sys/admin/loadDictionary',///分页获取用户服务地址列表/活动
    findServerCommunity:api+'app/system/serverCommunity/findServerCommunity',///分页获取用户服务地址列表/活动
    flowPage:api+'app/user/points/flow/page',///分页获取用户服务地址列表/活动
    findMobileCode:api+'base/verifyCode/findMobileCode',///分页获取用户服务地址列表/活动
    findUserDemandActivityByPage:api+'app/demand/activity/findUserDemandActivityByPage',///分页获取用户服务地址列表/活动
    pointsdonate:api+'app/user/points/donate',///分页获取用户服务地址列表/活动
    findDemandGenre:api+'app/demand/genre/findDemandGenre/y',///分页获取用户服务地址列表/活动
    findDemandCategory:api+'app/demand/genre/findDemandCategory',///分页获取用户服务地址列表/活动
    findServerGroup:api+'app/demand/genre/findServerGroup',///分页获取用户服务地址列表/活动
    saveActivity:api+'app/demand/activity/saveActivity',///分页获取用户服务地址列表/活动
    findByActivity:api+'app/demand/activity/apply/findByActivity',///分页获取用户服务地址列表/活动
    serverDelete:api+'app/server/delete/',///分页获取用户服务地址列表/活动
    addMsgBoard:api+'app/demand/activity/addMsgBoard',///分页获取用户服务地址列表/活动
    activityApply:api+'app/demand/activity/apply/activity/',///分页获取用户服务地址列表/活动
    findUserInfoByid:api+'app/user/core/findUserInfo/',///分页获取用户服务地址列表/活动
    applyAudit:api+'app/demand/activity/apply/audit/',///分页获取用户服务地址列表/活动
    updateActivity:api+'app/demand/activity/updateActivity',///分页获取用户服务地址列表/活动
    activityCance:api+'app/demand/activity/cancel/',///分页获取用户服务地址列表/活动
    applyCancel:api+'app/demand/activity/apply/cancel/',///分页获取用户服务地址列表/活动
    activityCompelete:api+'app/demand/activity/activity/complete/',///分页获取用户服务地址列表/活动
    addEvaluation:api+'app/user/evaluation/addEvaluation',///分页获取用户服务地址列表/活动
    findAppUserEvaluationByPage:api+'app/user/evaluation/findAppUserEvaluationByPage',///分页获取用户服务地址列表/活动
    feedbackSave:api+'app/system/feedback/save',///分页获取用户服务地址列表/活动
    findFeedBackByPage:api+'app/system/feedback/findFeedBackByPage',///分页获取用户服务地址列表/活动
    findElegantDemeanourByPage:api+'app/system/findElegantDemeanourByPage',///分页获取用户服务地址列表/活动
    findEvaluation:api+'app/user/evaluation/findEvaluation/',///分页获取用户服务地址列表/活动
    activityDelete:api+'app/demand/activity/delete/',///分页获取用户服务地址列表/活动
    elegantDemeanour:api+'app/system/elegantDemeanour/findOne/',///分页获取用户服务地址列表/活动
    findServerAbout:api+'app/system/findServer-about/',///分页获取用户服务地址列表/活动
    randomCode:api+'base/verifyCode/randomCode',///分页获取用户服务地址列表/活动
    findUserPotentialByPage:api+'app/demand/activity/findUserPotentialByPage',///分页获取用户服务地址列表/活动
    activityInviteUser:api+'app/demand/activity/inviteUser',///分页获取用户服务地址列表/活动
    findPotentialInvite:api+'app/demand/activity/findPotentialInvite',///分页获取用户服务地址列表/活动
    activityStart:api+'app/demand/activity/activity-start/',///分页获取用户服务地址列表/活动
    prepay:api+'app/point/recharge/precreate/prepay',///微信支付宝二维码支付 预支付
    weixinQuery:api+'app/point/recharge/precreate/weixin/query/',///微信支付宝二维码支付 预支付
    applyAgree:api+'app/demand/activity/release/user/apply-agree/',///微信支付宝二维码支付 预支付
    applyStart:api+'app/demand/activity/user/apply-start/',///微信支付宝二维码支付 预支付
    findPaper:api+'app/paper/findPaper',///微信支付宝二维码支付 预支付
    paperSave:api+'app/paper/paper-question/save',///微信支付宝二维码支付 预支付
    findWelfareByPage:api+'app/system/findWelfareByPage',///微信支付宝二维码支付 预支付
    applyComplete:api+'app/demand/activity/user/apply-complete/',///微信支付宝二维码支付 预支付
  }
}



// WEBPACK FOOTER //
// ./src/constant/urlconstant.js